import React from 'react';
import { InternalIdControl } from 'src/components/common/InternalIdControl/InternalIdControl';
import { useInternalIdControlWrapper } from 'src/components/enterprise/features/Employee/components/Form/controls/InternalIdControlWrapper/hooks/useInternalIdControlWrapper';

export function InternalIdControlWrapper(): JSX.Element {
  const { rules } = useInternalIdControlWrapper();

  return <InternalIdControl name="internalId" id="internalId" rules={rules} />;
}
